import { CSSProperties } from 'react';

export const rangeHandlerStyle: CSSProperties = {
  width: 20,
  height: 20,
  marginTop: '-9px',
  backgroundImage:
    'linear-gradient(white, white), linear-gradient(105.05deg, #b36bff -14.86%, #5a75ff 104.8%)',
  backgroundClip: 'padding-box, border-box',
  backgroundOrigin: 'border-box',
  border: 'double 6px transparent',
  borderRadius: '50%',
};
